import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    fetchApplicationsPending: false,
    applications: [],
    updateApplicationPending: false,
    application: {},
  },
  actions,
  mutations,
};
